
(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const dialog = qs('#upgrade-products-modal');
  if (!dialog) return;

  const openers = qsa('[data-upgrades-open]');
  const closers = qsa('[data-upgrades-close]', dialog);
  const modalContent = qs('.upgrade-modal__content', dialog);
  let lastFocused = null;

  // Graceful fallback for browsers without <dialog> support
  if (!('showModal' in HTMLDialogElement.prototype)) {
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.hidden = true;
    dialog.showModal = function () { this.hidden = false; document.body.style.overflow = 'hidden'; };
    dialog.close = function () { this.hidden = true; document.body.style.overflow = ''; };
  }

  const trapFocus = (e) => {
    const focusables = qsa('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])', dialog)
      .filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    } else if (e.key === 'Escape') {
      dialog.close();
    }
  };

  openers.forEach(btn => {
    btn.addEventListener('click', () => {
      lastFocused = document.activeElement;
      dialog.showModal();
      // Focus on the title or first interactive content
      const target = qs('#upgrade-modal-title', dialog) || qs('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', dialog);
      target && target.focus();
      document.addEventListener('keydown', trapFocus);
    });
  });

  closers.forEach(el => el.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', (event) => {
    if (!modalContent || event.defaultPrevented) return;
    if (!modalContent.contains(event.target)) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', () => {
    document.removeEventListener('keydown', trapFocus);
    lastFocused && lastFocused.focus();
  });
  
})();
